import script from "./ModificarComponentes.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModificarComponentes.vue?vue&type=script&lang=ts&setup=true"

import "./ModificarComponentes.vue?vue&type=style&index=0&id=262e7158&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-262e7158"]])

export default __exports__